"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.details = exports.otherMuscles = void 0;
exports.otherMuscles = [
    {
        isFaded: false,
        name: 'Acromial Part of Deltoid (Right)',
        identifier: 'muscle1',
    },
    {
        isFaded: false,
        name: 'Clavicular Part of Deltoid (Right)',
        identifier: 'muscle2',
    },
    {
        isFaded: false,
        name: 'Coracobrachialis Muscle (Right)',
        identifier: 'muscle3',
    },
    {
        isFaded: false,
        name: 'Scapular Spinal Part of Deltoid Muscle (Right)',
        identifier: 'muscle4',
    },
    {
        isFaded: false,
        name: 'Teres Minor Muscle (Right)',
        identifier: 'muscle5',
    },
];
exports.details = {
    parts: exports.otherMuscles,
    allFaded: false,
    selectedPartIndex: 0,
    type: 0,
};
